// 庫存管理系統資料模型
// Inventory Management System Data Model

// 產品類別資料
export const productCategories = [
  { id: 'raw-material', name: '原材料', name_en: 'Raw Materials', icon: 'Layers', color: '#4CAF50' },
  { id: 'semi-finished', name: '半成品', name_en: 'Semi-finished Products', icon: 'Tool', color: '#FF9800' },
  { id: 'finished', name: '成品', name_en: 'Finished Products', icon: 'Package', color: '#2196F3' },
  { id: 'packaging', name: '包裝材料', name_en: 'Packaging Materials', icon: 'Box', color: '#9C27B0' },
  { id: 'spare-parts', name: '零配件', name_en: 'Spare Parts', icon: 'Settings', color: '#607D8B' },
];

// 倉庫資料
export const warehouses = [
  { 
    id: 'wh-main', 
    name: '主要倉庫', 
    name_en: 'Main Warehouse',
    location: '台北市內湖區', 
    manager: '張明德',
    capacity: 5000,
    usedCapacity: 3250,
    image: 'https://images.unsplash.com/photo-1553413077-190dd305871c?w=800&h=600&fit=crop'
  },
  { 
    id: 'wh-production', 
    name: '生產線倉庫', 
    name_en: 'Production Warehouse',
    location: '台北市內湖區', 
    manager: '李志明',
    capacity: 2000,
    usedCapacity: 1800,
    image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&h=600&fit=crop'
  },
  { 
    id: 'wh-shipping', 
    name: '出貨倉庫', 
    name_en: 'Shipping Warehouse',
    location: '新北市汐止區', 
    manager: '王建國',
    capacity: 3000,
    usedCapacity: 1200,
    image: 'https://images.unsplash.com/photo-1600494448850-6b1e3fc731a7?w=800&h=600&fit=crop'
  },
];

// 供應商資料
export const suppliers = [
  {
    id: 'sup-001',
    name: '台灣原料股份有限公司',
    name_en: 'Taiwan Raw Materials Co., Ltd.',
    contactPerson: '陳大明',
    phone: '02-2345-6789',
    email: 'contact@taiwanraw.com',
    address: '新北市新店區中正路123號',
    rating: 4.8,
    categories: ['raw-material'],
    image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&h=600&fit=crop'
  },
  {
    id: 'sup-002',
    name: '高品質包材有限公司',
    name_en: 'High Quality Packaging Co., Ltd.',
    contactPerson: '林小華',
    phone: '02-3456-7890',
    email: 'service@hqpackaging.com',
    address: '台北市信義區忠孝東路五段456號',
    rating: 4.5,
    categories: ['packaging'],
    image: 'https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?w=800&h=600&fit=crop'
  },
  {
    id: 'sup-003',
    name: '精密零件工業',
    name_en: 'Precision Parts Industry',
    contactPerson: '黃志偉',
    phone: '02-4567-8901',
    email: 'info@precisionparts.com',
    address: '桃園市中壢區中央西路789號',
    rating: 4.7,
    categories: ['spare-parts', 'semi-finished'],
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop'
  },
];

// 產品資料
export const products = [
  {
    id: 'prod-001',
    sku: 'RM-STEEL-001',
    name: '高碳鋼板',
    name_en: 'High Carbon Steel Plate',
    category: 'raw-material',
    description: '高品質碳鋼板，適用於精密零件製造',
    unit: '公斤',
    unitPrice: 75.5,
    reorderPoint: 500,
    safetyStock: 300,
    leadTime: 7, // 天
    supplier: 'sup-001',
    image: 'https://images.unsplash.com/photo-1605001011156-cbf0b0ae08f3?w=800&h=600&fit=crop'
  },
  {
    id: 'prod-002',
    sku: 'RM-ALUM-001',
    name: '鋁合金板',
    name_en: 'Aluminum Alloy Plate',
    category: 'raw-material',
    description: '輕量化鋁合金板材，適用於外殼製造',
    unit: '公斤',
    unitPrice: 120.75,
    reorderPoint: 300,
    safetyStock: 150,
    leadTime: 5, // 天
    supplier: 'sup-001',
    image: 'https://images.unsplash.com/photo-1531761535209-180857b9f904?w=800&h=600&fit=crop'
  },
  {
    id: 'prod-003',
    sku: 'RM-COPPER-001',
    name: '銅線',
    name_en: 'Copper Wire',
    category: 'raw-material',
    description: '高導電性銅線，適用於電子元件製造',
    unit: '公尺',
    unitPrice: 35.25,
    reorderPoint: 1000,
    safetyStock: 500,
    leadTime: 3, // 天
    supplier: 'sup-001',
    image: 'https://images.unsplash.com/photo-1518623001395-125242310d0c?w=800&h=600&fit=crop'
  },
  {
    id: 'prod-004',
    sku: 'PKG-BOX-001',
    name: '標準包裝盒',
    name_en: 'Standard Packaging Box',
    category: 'packaging',
    description: '標準尺寸產品包裝盒，環保材質',
    unit: '個',
    unitPrice: 12.5,
    reorderPoint: 2000,
    safetyStock: 1000,
    leadTime: 2, // 天
    supplier: 'sup-002',
    image: 'https://images.unsplash.com/photo-1575486234793-6c267db4fbaa?w=800&h=600&fit=crop'
  },
  {
    id: 'prod-005',
    sku: 'PKG-TAPE-001',
    name: '包裝膠帶',
    name_en: 'Packaging Tape',
    category: 'packaging',
    description: '高黏性包裝膠帶，防水耐用',
    unit: '卷',
    unitPrice: 45.0,
    reorderPoint: 500,
    safetyStock: 200,
    leadTime: 2, // 天
    supplier: 'sup-002',
    image: 'https://images.unsplash.com/photo-1627384113743-6bd5a479fffd?w=800&h=600&fit=crop'
  },
  {
    id: 'prod-006',
    sku: 'SP-GEAR-001',
    name: '精密齒輪',
    name_en: 'Precision Gear',
    category: 'spare-parts',
    description: '高精度金屬齒輪，適用於機械傳動系統',
    unit: '個',
    unitPrice: 85.5,
    reorderPoint: 300,
    safetyStock: 150,
    leadTime: 10, // 天
    supplier: 'sup-003',
    image: 'https://images.unsplash.com/photo-1569398079729-2d09a569a25e?w=800&h=600&fit=crop'
  },
  {
    id: 'prod-007',
    sku: 'SP-BEARING-001',
    name: '軸承',
    name_en: 'Bearing',
    category: 'spare-parts',
    description: '高精度軸承，適用於旋轉設備',
    unit: '個',
    unitPrice: 65.75,
    reorderPoint: 400,
    safetyStock: 200,
    leadTime: 7, // 天
    supplier: 'sup-003',
    image: 'https://images.unsplash.com/photo-1621110419507-1a5e90761819?w=800&h=600&fit=crop'
  },
  {
    id: 'prod-008',
    sku: 'SF-HOUSING-001',
    name: '產品外殼',
    name_en: 'Product Housing',
    category: 'semi-finished',
    description: '產品外殼半成品，待進一步加工',
    unit: '個',
    unitPrice: 150.0,
    reorderPoint: 200,
    safetyStock: 100,
    leadTime: 5, // 天
    supplier: 'sup-003',
    image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800&h=600&fit=crop'
  },
  {
    id: 'prod-009',
    sku: 'FP-DEVICE-001',
    name: '智能裝置',
    name_en: 'Smart Device',
    category: 'finished',
    description: '完成品智能裝置，已測試合格',
    unit: '台',
    unitPrice: 4500.0,
    reorderPoint: 50,
    safetyStock: 25,
    leadTime: 0, // 天 (自產)
    supplier: null,
    image: 'https://images.unsplash.com/photo-1546868871-7041f2a55e12?w=800&h=600&fit=crop'
  },
  {
    id: 'prod-010',
    sku: 'FP-COMPONENT-001',
    name: '電子元件模組',
    name_en: 'Electronic Component Module',
    category: 'finished',
    description: '完成品電子元件模組，可直接銷售',
    unit: '個',
    unitPrice: 1200.0,
    reorderPoint: 100,
    safetyStock: 50,
    leadTime: 0, // 天 (自產)
    supplier: null,
    image: 'https://images.unsplash.com/photo-1555664424-778a1e5e1b48?w=800&h=600&fit=crop'
  }
];

// 庫存交易類型
export const transactionTypes = [
  { id: 'purchase-receipt', name: '採購入庫', name_en: 'Purchase Receipt', effect: 'increase' },
  { id: 'sales-issue', name: '銷售出庫', name_en: 'Sales Issue', effect: 'decrease' },
  { id: 'production-issue', name: '生產領料', name_en: 'Production Issue', effect: 'decrease' },
  { id: 'production-receipt', name: '生產入庫', name_en: 'Production Receipt', effect: 'increase' },
  { id: 'return-receipt', name: '退貨入庫', name_en: 'Return Receipt', effect: 'increase' },
  { id: 'return-issue', name: '退貨出庫', name_en: 'Return Issue', effect: 'decrease' },
  { id: 'adjustment-increase', name: '盤盈調整', name_en: 'Adjustment Increase', effect: 'increase' },
  { id: 'adjustment-decrease', name: '盤虧調整', name_en: 'Adjustment Decrease', effect: 'decrease' },
  { id: 'transfer-out', name: '調撥出庫', name_en: 'Transfer Out', effect: 'decrease' },
  { id: 'transfer-in', name: '調撥入庫', name_en: 'Transfer In', effect: 'increase' },
];

// 庫存交易記錄
export const inventoryTransactions = [
  {
    id: 'trans-001',
    date: '2025-06-15',
    type: 'purchase-receipt',
    productId: 'prod-001',
    warehouseId: 'wh-main',
    quantity: 1000,
    unitPrice: 75.5,
    totalAmount: 75500,
    reference: 'PO-20250615-001',
    notes: '正常採購入庫',
    createdBy: 'user-001',
    createdAt: '2025-06-15T09:30:00'
  },
  {
    id: 'trans-002',
    date: '2025-06-16',
    type: 'purchase-receipt',
    productId: 'prod-002',
    warehouseId: 'wh-main',
    quantity: 500,
    unitPrice: 120.75,
    totalAmount: 60375,
    reference: 'PO-20250616-001',
    notes: '正常採購入庫',
    createdBy: 'user-001',
    createdAt: '2025-06-16T10:15:00'
  },
  {
    id: 'trans-003',
    date: '2025-06-18',
    type: 'production-issue',
    productId: 'prod-001',
    warehouseId: 'wh-main',
    quantity: 200,
    unitPrice: 75.5,
    totalAmount: 15100,
    reference: 'MO-20250618-001',
    notes: '生產領料',
    createdBy: 'user-002',
    createdAt: '2025-06-18T08:45:00'
  },
  {
    id: 'trans-004',
    date: '2025-06-20',
    type: 'production-receipt',
    productId: 'prod-009',
    warehouseId: 'wh-production',
    quantity: 50,
    unitPrice: 4500,
    totalAmount: 225000,
    reference: 'MO-20250618-001',
    notes: '生產完成入庫',
    createdBy: 'user-002',
    createdAt: '2025-06-20T16:30:00'
  },
  {
    id: 'trans-005',
    date: '2025-06-22',
    type: 'transfer-out',
    productId: 'prod-009',
    warehouseId: 'wh-production',
    quantity: 30,
    unitPrice: 4500,
    totalAmount: 135000,
    reference: 'TR-20250622-001',
    notes: '調撥至出貨倉庫',
    createdBy: 'user-003',
    createdAt: '2025-06-22T11:20:00'
  },
  {
    id: 'trans-006',
    date: '2025-06-22',
    type: 'transfer-in',
    productId: 'prod-009',
    warehouseId: 'wh-shipping',
    quantity: 30,
    unitPrice: 4500,
    totalAmount: 135000,
    reference: 'TR-20250622-001',
    notes: '從生產倉庫調入',
    createdBy: 'user-003',
    createdAt: '2025-06-22T11:25:00'
  },
  {
    id: 'trans-007',
    date: '2025-06-25',
    type: 'sales-issue',
    productId: 'prod-009',
    warehouseId: 'wh-shipping',
    quantity: 25,
    unitPrice: 4500,
    totalAmount: 112500,
    reference: 'SO-20250625-001',
    notes: '銷售出貨',
    createdBy: 'user-004',
    createdAt: '2025-06-25T14:10:00'
  },
  {
    id: 'trans-008',
    date: '2025-06-28',
    type: 'adjustment-increase',
    productId: 'prod-004',
    warehouseId: 'wh-main',
    quantity: 50,
    unitPrice: 12.5,
    totalAmount: 625,
    reference: 'ADJ-20250628-001',
    notes: '盤點盤盈',
    createdBy: 'user-001',
    createdAt: '2025-06-28T15:45:00'
  },
  {
    id: 'trans-009',
    date: '2025-06-28',
    type: 'adjustment-decrease',
    productId: 'prod-005',
    warehouseId: 'wh-main',
    quantity: 10,
    unitPrice: 45,
    totalAmount: 450,
    reference: 'ADJ-20250628-002',
    notes: '盤點盤虧',
    createdBy: 'user-001',
    createdAt: '2025-06-28T16:20:00'
  },
  {
    id: 'trans-010',
    date: '2025-07-01',
    type: 'return-receipt',
    productId: 'prod-009',
    warehouseId: 'wh-shipping',
    quantity: 2,
    unitPrice: 4500,
    totalAmount: 9000,
    reference: 'RET-20250701-001',
    notes: '客戶退貨',
    createdBy: 'user-004',
    createdAt: '2025-07-01T09:15:00'
  }
];

// 當前庫存狀態
export const inventoryStatus = [
  {
    productId: 'prod-001',
    warehouseId: 'wh-main',
    quantity: 800,
    lastUpdated: '2025-06-18T08:45:00'
  },
  {
    productId: 'prod-002',
    warehouseId: 'wh-main',
    quantity: 500,
    lastUpdated: '2025-06-16T10:15:00'
  },
  {
    productId: 'prod-003',
    warehouseId: 'wh-main',
    quantity: 1500,
    lastUpdated: '2025-06-10T11:30:00'
  },
  {
    productId: 'prod-004',
    warehouseId: 'wh-main',
    quantity: 2550,
    lastUpdated: '2025-06-28T15:45:00'
  },
  {
    productId: 'prod-005',
    warehouseId: 'wh-main',
    quantity: 490,
    lastUpdated: '2025-06-28T16:20:00'
  },
  {
    productId: 'prod-006',
    warehouseId: 'wh-main',
    quantity: 350,
    lastUpdated: '2025-06-05T14:20:00'
  },
  {
    productId: 'prod-007',
    warehouseId: 'wh-main',
    quantity: 420,
    lastUpdated: '2025-06-08T10:45:00'
  },
  {
    productId: 'prod-008',
    warehouseId: 'wh-main',
    quantity: 180,
    lastUpdated: '2025-06-12T13:15:00'
  },
  {
    productId: 'prod-009',
    warehouseId: 'wh-production',
    quantity: 20,
    lastUpdated: '2025-06-22T11:20:00'
  },
  {
    productId: 'prod-009',
    warehouseId: 'wh-shipping',
    quantity: 7,
    lastUpdated: '2025-07-01T09:15:00'
  },
  {
    productId: 'prod-010',
    warehouseId: 'wh-production',
    quantity: 85,
    lastUpdated: '2025-06-15T15:30:00'
  }
];

// 庫存分析
export const inventoryAnalytics = {
  totalInventoryValue: 1245750,
  inventoryTurnover: 4.2,
  averageDaysToSell: 87,
  stockoutRate: 0.5,
  excessInventoryRate: 3.2,
  slowMovingRate: 5.8,
  categoryBreakdown: [
    { category: 'raw-material', value: 450875, percentage: 36.2 },
    { category: 'semi-finished', value: 27000, percentage: 2.2 },
    { category: 'finished', value: 697500, percentage: 56.0 },
    { category: 'packaging', value: 38375, percentage: 3.1 },
    { category: 'spare-parts', value: 32000, percentage: 2.5 }
  ],
  warehouseUtilization: [
    { warehouseId: 'wh-main', utilization: 65 },
    { warehouseId: 'wh-production', utilization: 90 },
    { warehouseId: 'wh-shipping', utilization: 40 }
  ],
  reorderAlerts: [
    { productId: 'prod-003', currentStock: 1500, reorderPoint: 1000, status: 'safe' },
    { productId: 'prod-005', currentStock: 490, reorderPoint: 500, status: 'warning' },
    { productId: 'prod-008', currentStock: 180, reorderPoint: 200, status: 'alert' }
  ],
  monthlyTrends: [
    { month: '2025-01', value: 980000 },
    { month: '2025-02', value: 1050000 },
    { month: '2025-03', value: 1120000 },
    { month: '2025-04', value: 1180000 },
    { month: '2025-05', value: 1210000 },
    { month: '2025-06', value: 1245750 }
  ]
};
